//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import Cuid from '@models/Cuid';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { InstagramPostStatus } from '@models/InstagramPostStatus';
import PostableId from '@models/PostableId';
import { UniversalPostableCustomStatus } from '@models/UniversalPostableCustomStatus';
import UserId from '@models/UserId';

export interface IScheduledInstagramStoryGroup {
  id: PostableId;
  postStatus: InstagramPostStatus;
  userActionStatus: UniversalPostableCustomStatus;
  scheduledTime: Date;
  instagramStoryGroup: IInstagramStoryGroup;
}

export interface IInstagramStoryGroup {
  storyClips: IInstagramStoryGroupClip[];
  notifyUserId: UserId;
}

export interface IInstagramStoryGroupClip {
  cuid?: Cuid;
  customizations: IInstagramStoryGroupClipCustomization[];

  mediaItem?: IMlsMediaItem;
}

export interface InstagramManualStoryClip {
  cuid?: Cuid;
  customizations: IInstagramStoryGroupClipCustomization[];

  fullSwipeUpLink?: string;
  showroomShortLink?: string;
  showroomPreviewUrl?: string;
  hasAugmentedSwipeUpLink?: boolean;
  hasUpdatedShowroomToContextual?: boolean;
}

export interface IInstagramStoryGroupClipCustomization {
  customizationType: InstagramStoryGroupClipCustomizationType;
  value?: string;
}

export enum InstagramStoryGroupClipCustomizationType {
  SwipeUpUrl = 'SwipeUpUrl',
  TextOverlay = 'TextOverlay',
  Location = 'Location',
  AtMention = 'AtMention',
  Hashtag = 'Hashtag',
  Question = 'Question',
  Poll = 'Poll',
  Gif = 'Gif',
  Other = 'Other',
}
